export default __webpack_public_path__ + "static/media/services_iot.327c7582.png";